import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';
import { capitalize } from '../../../helpers/SubscriptionsUtil';

export default function ConvertSuccess({ onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });
  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        appCurrency,
      } = {},
    },
  } = config;

  return (
    <div
      id="convert-success"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            <h4>{t('convert_success')}</h4>
          </div>
          <div className="modal-body">
            <div className="row">
              <p className="col-xs-12">
                {t('convert_success_text', { appCurrency: capitalize(t(appCurrency?.toLowerCase())) })}
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-primary btn-full"
                onClick={onClose}
              >
                {t('cashout_ok')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ConvertSuccess.propTypes = {
  onClose: PropTypes.func.isRequired,
};
